module.exports = __webpack_public_path__ + "img/logos_customer_20.c7e21c8a.svg";